import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import AnswerOption from './AnswerOption';
import { AssignmentQuestionAnswer } from '../../../state/assignment-edit.types';

interface AnswerOptionListProps {
  answers: AssignmentQuestionAnswer[];
  handleDeleteAnswer(id: string): void;
  handleAnswerUpdate(id: string, data: object): void;
  isOrdered: boolean;
  isPair:boolean;
}
const AnswerOptionList: React.FC<AnswerOptionListProps> = (
  props: AnswerOptionListProps
) => {
  const { answers, handleAnswerUpdate, handleDeleteAnswer, isOrdered, isPair } = props;

  return (
    <Grid container spacing={2}>
      {answers.map((answer: any, index: number) => {
        return (
          <Grid key={answer.id} item xs={12}>
            <AnswerOption
              answer={answer}
              number={index + 1}
              isOrdered={isOrdered}
              isPair={isPair}
              handleAnswerUpdate={handleAnswerUpdate}
              handleDeleteAnswer={handleDeleteAnswer}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default AnswerOptionList;
